import { useState } from 'react';
import { token as liveToken } from '../auth/session';
import { useT } from '../i18n/i18n';

export default function DownloadDataSection() {
  const t = useT();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function download() {
    setBusy(true);
    setError(null);
    try {
      const bearer = await liveToken();
      const res = await fetch('/api/me/account/export', {
        headers: bearer ? { Authorization: `Bearer ${bearer}` } : {},
        credentials: 'omit',
      });
      if (!res.ok) throw new Error();
      const url = URL.createObjectURL(await res.blob());
      const link = document.createElement('a');
      link.href = url;
      link.download = /filename="?([^";]+)"?/i.exec(res.headers.get('Content-Disposition') ?? '')?.[1] ?? 'easylearning-data.zip';
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch {
      setError(t('Your file could not be made just now. Please try again, or email {email}.', { email: 'support@fractalon.net' }));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <h2>{t('Download all my data')}</h2>
      <p>
        {t('One file with everything EasyLearning holds about you and your learners: your account, settings, learners, programs, every practice, plans, rewards, Talk Boards, and the pictures and recordings you added.')}
      </p>
      {error && <p className="error" role="alert">{error}</p>}
      <div className="toolbar">
        <button type="button" className="btn secondary" onClick={() => void download()} disabled={busy}>
          {busy ? t('Making your file…') : t('Download all my data')}
        </button>
      </div>
    </div>
  );
}
